import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=723cf0da"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoModal.vue?vue&type=style&index=0&id=723cf0da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports